import { type SxProps, type Theme } from "@mui/material/styles";

/**
 * Figma draws the text button with no box: the height is the label's line-height (16 / 20 / 24), and
 * hover only steps the label to `dark` — which the `MuiButton` theme entry already does — with no tint.
 * MUI's ripple and focus pulse stay.
 */
export const TEXT_BUTTON_SX: SxProps<Theme> = {
  padding: 0,
  backgroundColor: "transparent",
  // MUI insets the start/end spinner by its own text-variant padding, which this button no longer has.
  "&.MuiButton-loadingPositionStart .MuiButton-loadingIndicator": { left: 0 },
  "&.MuiButton-loadingPositionEnd .MuiButton-loadingIndicator": { right: 0 },
};
